module.exports = __webpack_public_path__ + "static/media/اكواخ ريفيه في سويسرا.7be6059e.jpg";